<div class="points-section">
	<!-- Punkte aus Filter - nur wenn keine Bereiche/Rechtecke aber Filter aktiv -->
	<div *ngIf="pps.hasFilterOnly()" class="d-flex align-items-center gap-2 mb-2">
		<button class="btn btn-sm btn-outline-dark btn-xs"
				(click)="zoomToFilterPoints()"
				[disabled]="pps.filterCount() === 0"
				title="Zu Punkten zoomen">
			<i class="bi bi-search"></i>
		</button>
		<span class="badge text-dark" style="background-color: rgba(255, 165, 0, 0.8);">{{ pps.filterCount() }}</span>
		<span class="flex-grow-1">Punkte aus Filter</span>
	</div>

	<!-- Dem Projekt zugewiesene Punkte - immer anzeigen wenn vorhanden -->
	<div *ngIf="pps.assignedCount() > 0" class="d-flex align-items-center gap-2 mb-2">
		<button class="btn btn-sm btn-outline-dark btn-xs"
				(click)="zoomToAssignedPoints()"
				title="Zu zugewiesenen Punkten zoomen">
			<i class="bi bi-search"></i>
		</button>
		<span class="badge" style="background-color: rgba(0, 100, 255, 0.8);">{{ pps.assignedCount() }}</span>
		<span class="flex-grow-1">Dem Projekt zugewiesen</span>
	</div>

	<!-- Rechteckauswahl - nur wenn Punkte vorhanden -->
	<div *ngIf="pps.boundsCount() > 0" class="d-flex align-items-center gap-2 mb-2">
		<button class="btn btn-sm btn-outline-dark btn-xs"
				(click)="zoomToBoundsPoints()"
				title="Zu Punkten zoomen">
			<i class="bi bi-search"></i>
		</button>
		<span class="badge text-dark" style="background-color: rgba(255, 165, 0, 0.8);">{{ pps.boundsCount() }}</span>
		<span class="flex-grow-1">Rechteckauswahl</span>
	</div>

	<!-- Projektbereiche - immer anzeigen wenn Regions existieren -->
	<div *ngIf="pps.regionsCount() > 0" class="d-flex align-items-center gap-2 mb-2">
		<button class="btn btn-sm btn-outline-dark btn-xs"
				(click)="zoomToRegionPoints()"
				[disabled]="pps.regionCount() === 0"
				title="Zu Punkten zoomen">
			<i class="bi bi-search"></i>
		</button>
		<span class="badge"
			  [class.text-dark]="pps.regionCount() > 0"
			  [style.background-color]="pps.regionCount() > 0 ? 'rgba(255, 165, 0, 0.8)' : null"
			  [class.bg-secondary]="pps.regionCount() === 0">
			{{ pps.regionCount() }}
		</span>
		<span class="flex-grow-1">Punkte im Projektbereich</span>
		<div class="form-check form-switch mb-0">
			<input class="form-check-input" type="checkbox"
				   [ngModel]="pps.hasActiveRegions()"
				   [indeterminate]="pps.regionsIndeterminate()"
				   [disabled]="oms.offlineMode() || !ps.isOwner()"
				   (ngModelChange)="toggleRegionPoints($event)">
		</div>
	</div>

	<!-- Gesamt - wenn Punkte außerhalb des Projektbereichs vorhanden -->
	<ng-container *ngIf="pps.boundsCount() > 0 || pps.assignedCount() > 0 || pps.hasFilterOnly()">
		<hr class="my-2">
		<div class="d-flex align-items-center gap-2">
			<button class="btn btn-sm btn-outline-dark btn-xs"
					(click)="zoomToAllPoints()"
					[disabled]="pps.totalCount() === 0"
					title="Zu Punkten zoomen">
				<i class="bi bi-search"></i>
			</button>
			<span class="badge"
				  [class.bg-dark]="pps.totalCount() > 0"
				  [class.bg-secondary]="pps.totalCount() === 0">
				{{ pps.totalCount() }}
			</span>
			<span class="flex-grow-1 fw-bold">Gesamt im Projekt</span>
		</div>
	</ng-container>

	<!-- Download-Status für Punkte -->
	<ng-container *ngIf="pps.totalCount() > 0 && pps.isInitialized()">
		<hr class="my-2">
		<div class="d-flex align-items-center gap-2">
			<span class="flex-grow-1">Offline-Verfügbarkeit</span>
			<button class="btn btn-sm btn-outline-dark"
					(click)="downloadPoints()"
					[disabled]="pps.pointsDownloadStatus() === 'complete' || oms.offlineMode()"
					title="Punkte für Offline-Nutzung herunterladen">
				<i class="bi"
					[class.bi-cloud]="pps.pointsDownloadStatus() === 'none'"
					[class.bi-cloud-check]="pps.pointsDownloadStatus() === 'complete'"
					[class.text-success]="pps.pointsDownloadStatus() === 'complete'"></i>
			</button>
		</div>
	</ng-container>
</div>
